import template from './swag-cms-extensions-form-editor-group-field.html.twig';
import './swag-cms-extensions-form-editor-group-field.scss';

export default {
    template,
    inject: [
        'repositoryFactory',
    ],
    mixins: [
        'cms-state',
        'position',
    ],
    props: {
        field: {
            type: Object,
            required: true,
        },
        groupId: {
            type: String,
            required: true,
        },
        groupCount: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            showMoveFieldToGroupModal: false,
            moveToGroupId: null,
        };
    },
    computed: {
        activeItem() {
            return Shopware.Store.get('swCmsDetailCurrentCustomForm').activeItem;
        },
        groups() {
            return Shopware.Store.get('swCmsDetailCurrentCustomForm').form.groups;
        },
        fieldHasError() {
            return !!Shopware.Store.get('error').getErrorsForEntity(
                'swag_cms_extensions_form_group_field',
                this.field.id,
            );
        },
        moveToGroups() {
            return this.groups.filter(group => group.id !== this.groupId);
        },
        isActive() {
            return this.field.id === this.activeItem.id;
        },
        fieldDragData() {
            return {
                delay: 200,
                dragGroup: `editor-field-${this.groupId}`,
                data: { field: this.field },
                onDragEnter: this.onFieldDragSort,
                onDrop: this.onFieldDragStop,
            };
        },
        fieldDropData() {
            return {
                dragGroup: `editor-field-${this.groupId}`,
                data: { field: this.field },
            };
        },
        fieldRepository() {
            return this.repositoryFactory.create('swag_cms_extensions_form_group_field');
        },
    },

    methods: {
        onTitleClick() {
            Shopware.Store.get('swCmsDetailCurrentCustomForm').activeItem = this.field;
        },

        onDelete() {
            Shopware.Store.get('swCmsDetailCurrentCustomForm').deleteField(this.field.id, this.groupId);

            const errorStore = Shopware.Store.get('error');

            const errors = errorStore.getErrorsForEntity(
                'swag_cms_extensions_form_group_field',
                this.field.id,
            );

            if (!errors) {
                return;
            }

            Object.keys(errors).forEach((key) => {
                errorStore.removeApiError(errors[key].selfLink);
            });
        },

        onDuplicate() {
            Shopware.Store.get('swCmsDetailCurrentCustomForm').duplicateField(this.groupId, this.field.id, this.fieldRepository, Shopware.Context.api);
        },

        onEdit() {
            Shopware.Store.get('swCmsDetailCurrentCustomForm').activeItem = this.field;
        },

        onMoveDown() {
            Shopware.Store.get('swCmsDetailCurrentCustomForm').moveItem(this.field.id, this.raisePositionValue);
        },

        onMoveUp() {
            Shopware.Store.get('swCmsDetailCurrentCustomForm').moveItem(this.field.id, this.lowerPositionValue);
        },

        onFieldDragStop(dragData) {
            Shopware.Store.get('swCmsDetailCurrentCustomForm').setFieldProperty(dragData.field.id, 'isDragging', false);
        },

        onFieldDragSort(dragData, dropData, validDrop) {
            if (!validDrop) {
                return;
            }

            if (dragData.field.position !== dropData.field.position) {
                Shopware.Store.get('swCmsDetailCurrentCustomForm').setFieldProperty(
                    dragData.field.id,
                    'isDragging',
                    true,
                );
                Shopware.Store.get('swCmsDetailCurrentCustomForm').setItemPosition(
                    dragData.field.id,
                    dropData.field.position,
                    dragData.field.position,
                    this.lowerPositionValue,
                    this.raisePositionValue,
                );
            }
        },

        onMoveToGroupModalOpen() {
            this.showMoveFieldToGroupModal = true;
        },

        onMoveToGroupModalClose() {
            this.showMoveFieldToGroupModal = false;
        },

        moveFieldToGroup() {
            this.onMoveToGroupModalClose();

            this.$nextTick(() => {
                Shopware.Store.get('swCmsDetailCurrentCustomForm').moveFieldToGroup(
                    this.moveToGroupId,
                    this.groupId,
                    this.field.id,
                    this.fieldRepository,
                    Shopware.Context.api,
                );
            });
        },
    },
}
